import React from 'react';
const IconFormCheckSquareOutlined = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 3V21H21V3H3ZM19 19H5V5H19V19ZM17.71 9.71L16.29 8.29L11 13.59L8.21 10.79L6.79 12.21L11 16.41L17.71 9.71Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconFormCheckSquareOutlined;